import React from 'react';
import { Button, Table, Badge } from 'react-bootstrap';
import { Calendar, PlusCircle } from 'lucide-react';

import SettingsCard from '../SettingsCard';
import { EmptyState } from '../../Common/EmptyState';

// Räkenskapsår — its own settings route since the Bokföring split. Data is
// lazy-loaded in the CompanySettings shell on first visit and passed in as
// props; the create-modal lives in the shell.
const FiscalYearsSection = ({
  fiscalYears,
  setShowCreateFiscalYearModal,
  navigateToFiscalYearDetails,
  handleFiscalYearAction,
}) => (
  <SettingsCard
    id="rakenskapsar"
    icon={Calendar}
    title="Räkenskapsår"
    subtitle="Hantera och konfigurera räkenskapsår för ditt företag"
    actions={
      <Button
        variant="primary"
        onClick={() => setShowCreateFiscalYearModal(true)}
        className="d-flex align-items-center gap-2"
      >
        <PlusCircle size={16} />
        Skapa nytt räkenskapsår
      </Button>
    }
  >
    {fiscalYears.length > 0 ? (
      <div className="modern-table-container">
        <Table responsive hover className="modern-table">
          <thead>
            <tr>
              <th>Räkenskapsår</th>
              <th>Period</th>
              <th>Status</th>
              <th>Redovisningsmetod</th>
              <th>Momsperiod</th>
              <th>Åtgärder</th>
            </tr>
          </thead>
          <tbody>
            {fiscalYears.map((year) => (
              <tr
                key={year.fiscal_year_id}
                onClick={navigateToFiscalYearDetails(year.fiscal_year_id)}
                className="clickable-row"
              >
                <td>
                  <div className="table-cell-content">
                    <div className="fiscal-year-badge">{year.year}</div>
                  </div>
                </td>
                <td>
                  <div className="table-cell-content">
                    <div className="date-range">
                      <small className="text-muted">
                        {new Date(year.start_date).toLocaleDateString('sv-SE')} -
                        {new Date(year.end_date).toLocaleDateString('sv-SE')}
                      </small>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="table-cell-content">
                    <Badge
                      variant={year.state === 'open' ? 'success' : 'secondary'}
                      className="status-badge"
                    >
                      {year.state === 'open' ? 'Öppen' : 'Stängd'}
                    </Badge>
                  </div>
                </td>
                <td>
                  <div className="table-cell-content">
                    <span className="method-text">
                      {year.accounting_method === 'accrual' ? 'Faktureringsmetoden' : 'Kontantmetoden'}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="table-cell-content">
                    <span className="vat-period-text">
                      {year.vat_period === 'monthly' ? 'Månadsvis'
                        : year.vat_period === 'quarterly' ? 'Kvartalsvis' : 'Årsvis'}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="table-actions">
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleFiscalYearAction(
                          year.fiscal_year_id,
                          year.state === 'open' ? 'close' : 'open'
                        );
                      }}
                      variant={year.state === 'open' ? 'outline-warning' : 'outline-success'}
                      size="sm"
                      className="action-button"
                    >
                      {year.state === 'open' ? 'Stäng år' : 'Öppna år'}
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    ) : (
      <EmptyState
        icon={Calendar}
        title="Inga räkenskapsår skapade än"
        description={'Skapa ditt första räkenskapsår för att komma igång med bokföringen. '
          + 'Ett räkenskapsår kan också skapas genom att importera bokföringen från ett annat system.'}
        actions={
          <Button variant="primary" onClick={() => setShowCreateFiscalYearModal(true)}>
            <PlusCircle className="me-2" size={16} />
            Skapa räkenskapsår
          </Button>
        }
      />
    )}
  </SettingsCard>
);

export default FiscalYearsSection;
